import { API_URLS } from '../constants/apiUrls';
import { IFlightAllocationReq } from '../interfaces/flightAllocationReq';
import axiosClient from './axiosClient';

const flightApi = {
  getFlightAllocationDetails: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.FLIGHT_ALLOCATION}?ownerId=${ownerId}&date=${date}`,
    );
  },

  addFlightPickupAllocation: (payload: IFlightAllocationReq[]) => {
    return axiosClient.post(`${API_URLS.FLIGHT_ALLOCATION}`, payload);
  },

  getFlightUnAllocatedPaxDetails: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.FLIGHT_UNALLOCATION}?ownerId=${ownerId}&date=${date}`,
    );
  },
};

export default flightApi;
